import { render, staticRenderFns } from "./CounterWithDiscount.vue?vue&type=template&id=92eb7452&scoped=true&"
import script from "./CounterWithDiscount.vue?vue&type=script&lang=js&"
export * from "./CounterWithDiscount.vue?vue&type=script&lang=js&"
import style0 from "./CounterWithDiscount.vue?vue&type=style&index=0&id=92eb7452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92eb7452",
  null
  
)

export default component.exports